<template>
    <div class="sw-modal">
        <div v-click-outside="close" v-on:click="menuIndex = -1; showExistingVariableNames = false" class="sw-modal-content edit-variables">

            <!--  ----------------------- -->
            <!--  Listing Variables  view -->
            <!--  ----------------------- -->
            <template v-if="isListingVariables">
                <div class="row sw-modal-heading">
                    <div class="col">
                        <h4>${...} Edit Personalisation Variables</h4></div>
                </div>
                <div class="sw-modal-body">
<!--                    <div class="row">-->
<!--                        <div clas="col-12">-->
<!--                            Manage your personalisation variables that can be used-->
<!--                        </div>-->
<!--                    </div>-->
                    <div class="row">
                        <div class="col-12 text-right">
                            <input type="checkbox" v-model="showSystemVariables"/> Show system variables
                        </div>
                    </div>
                    <div class="row no-gutters">
                        <div class="col-12">
                            <h5 class="capitalize d-inline">General variables</h5>
                            <span class="d-none d-sm-inline text-note ml-2">(Always available)</span>
                        </div>
                        <div class="col-12 d-block d-sm-none text-note">(Always available)</div>
                    </div>
                    <table class="variables-values">
                        <thead>
                        <th class="markdown-syntax__hdr-element">Variable</th>
                        <th class="markdown-syntax__hdr-syntax">Value</th>
                        <th class="markdown-syntax__hdr-syntax"></th>
                        </thead>
                        <tr v-for="(variable, index) in variables" v-bind:key="index">
                            <template v-if="!variable.systemVariable || (showSystemVariables && variable.systemVariable)">
                                <td>{{variable.name}}</td>
                                <td>{{variable.value}}</td>
                                <td v-on:click.stop="toggleVariableMenu(index)">
                                    <i class="fas fa-ellipsis-h"></i>
                                    <div v-if="isShowVariableMenu(index)" class="variables-values__actions">
                                        <ul>
                                            <li v-on:click.stop="previewVariable(variable)"><span><i class="fas fa-eye"></i></span> Preview</li>
                                            <li v-if="!variable.systemVariable" v-on:click.stop="editVariable(variable)"><span><i class="fas fa-edit"></i></span> Edit</li>
                                            <li v-if="!variable.systemVariable" v-on:click.stop="confirmDeleteVariable(variable)"><span><i class="fas fa-trash-alt"></i></span> Delete</li>
                                        </ul>
                                    </div>
                                </td>
                            </template>
                        </tr>
                        <tr class="variables-values__add">
                            <td colspan="3">
                                <a v-on:click.stop="addVariable(false)" class="variables-values__add-button">+</a>
                            </td>
                        </tr>
                    </table>

                    <div class="row no-gutters">
                        <div class="col-12">
                            <h5 class="capitalize d-inline">Per {{getUnitTypeForDisplay}} variables</h5>
                            <span class="d-none d-sm-inline text-note ml-2">(Available if a booking is for that {{getUnitTypeForDisplay}})</span>
                        </div>
                        <div class="col-12 d-block d-sm-none text-note">(Available if a booking is for that {{getUnitTypeForDisplay}})</div>
                    </div>
                    <table class="variables-values">
                        <thead>
                        <th class="markdown-syntax__hdr-element">Variable</th>
                        <th class="markdown-syntax__hdr-element text-capitalize">{{getUnitTypeForDisplay}}</th>
                        <th class="markdown-syntax__hdr-syntax">Value</th>
                        <th class="markdown-syntax__hdr-syntax"></th>
                        </thead>
                        <tr v-for="(variable, index) in roomTypeVariables" v-bind:key="index">
                            <td>{{variable.name}}</td>
                            <td>{{getRoomTypeName(variable.roomTypeReference)}}</td>
                            <!--                        <td class="variables-values__expandable-cell">https://www.google.com/sdfsdf/sdf/sd/fsd/fs/df/sdf/sd/fs/dfsd</td>-->
                            <td>{{variable.value}}</td>
                            <td v-on:click.stop="toggleVariableMenu(variables.length + index)">
                                <i class="fas fa-ellipsis-h"></i>
                                <div v-if="isShowVariableMenu(variables.length + index)" class="variables-values__actions">
                                    <ul>
                                        <li v-on:click.stop="previewVariable(variable)"><span><i class="fas fa-eye"></i></span> Preview</li>
                                        <li v-on:click.stop="editVariable(variable)"><span><i class="fas fa-edit"></i></span> Edit</li>
                                        <li v-on:click.stop="confirmDeleteVariable(variable)"><span><i class="fas fa-trash-alt"></i></span> Delete</li>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                        <tr class="variables-values__add">
                            <td colspan="4">
                                <a v-on:click.stop="addVariable(true)" class="variables-values__add-button">+</a>
                            </td>
                        </tr>
                    </table>
                </div>
                <div class="sw-modal-actions">
                    <div v-if="waiting">
                        <Spinner/>
                    </div>
                    <div v-else class="row">
                        <div v-if="error" class="col-12">
                            <div class="alert alert-danger" role="alert">
                                {{error}}
                            </div>
                        </div>
                        <div class="col text-center">
                            <button class="btn btn-primary" v-on:click="close">Close</button>
                        </div>
                    </div>
                </div>
            </template>


            <!--  ----------------------- -->
            <!--  Editing a Variable view -->
            <!--  ----------------------- -->
            <template v-if="isEditingVariable">
                <div class="edit-form-component">
                    <div class="row sw-modal-heading">
                        <div class="col"><h4><i class="fas fa-user-alt"></i>Editing a Variable</h4></div>
                    </div>
                    <div class="sw-modal-body">
                        <ValidationObserver ref="variableForm">
                            <form v-on:submit.prevent="save()" >
                                <div class="row question">
                                    <div class="col-12 question__question">
                                        Assign to a {{getUnitTypeForDisplay}}?
                                    </div>
                                    <div class="col-12">
                                        <input type="radio" v-model="isRoomTypeVariable" v-bind:value="true" v-on:click="setAppliesToRoomType(true)"/> Yes
                                        <input type="radio" v-model="isRoomTypeVariable" v-bind:value="false" v-on:click="setAppliesToRoomType(false)"/> No
                                    </div>
                                </div>
                                <div class="row question" v-if="isRoomTypeVariable === true">
                                    <div class="col-12 question__question capitalize">
                                        {{getUnitTypeForDisplay}}
                                    </div>
                                    <div class="col-12">
                                        <ValidationProvider rules="required: isRoomTypeVariable === true" v-slot="{ errors }">
                                            <select ref="editVariableRoomType" v-model="editingVariable.roomTypeReference">
                                                <option value="null">Select a {{getUnitTypeForDisplay}}</option>
                                                <option v-for="(roomType, index) in establishment.roomTypes" v-bind:key="index" v-bind:value="roomType.reference">{{roomType.name}}</option>
                                            </select>
                                            <span class="form__error" v-if="errors">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="row question">
                                    <div class="col-12 question__question">
                                        Name
                                    </div>
                                    <div class="col-12 edit-variable__name">
                                        <ValidationProvider rules="required|min:3" v-slot="{ errors }">
                                            <input ref="editVariableName"
                                                   type="text"
                                                   v-model="editingVariable.name"
                                                   v-on:keydown.space.prevent
                                                   v-on:click.stop="showExistingVariableNames = true"
                                                   maxlength="256"
                                                   class="short-question">
                                            <div v-if="isRoomTypeVariable === true" v-on:click.stop="toggleShowingExistingVariables" class="edit-variable__use-existing">
                                                use existing
                                                <i v-if="!showExistingVariableNames" class="fa fa-chevron-down" aria-hidden="true"></i>
                                                <i v-if="showExistingVariableNames" class="fa fa-chevron-up" aria-hidden="true"></i>
<!--                                                <div v-if="showExistingVariableNames && uniqueRoomTypeVariableNames.length > 0"-->
<!--                                                     class="edit-variable__use-existing-options">-->
<!--                                                    <ul>-->
<!--                                                        <li v-for="(name, index) of uniqueRoomTypeVariableNames"-->
<!--                                                            v-on:click="copyVariableName(name)"-->
<!--                                                            v-bind:key="index">-->
<!--                                                            {{name}}-->
<!--                                                        </li>-->
<!--                                                    </ul>-->
<!--                                                </div>-->
                                            </div>
                                            <span class="form__error" v-if="errors">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                        <div class="auto-complete" v-show="showExistingVariableNames">
                                            <div class="auto-complete__inner">
                                                <div class="text-note">Copy an existing variable</div>
                                                <ul>
                                                    <li v-for="(name, index) of uniqueRoomTypeVariableNames"
                                                        v-on:click="copyVariableName(name)"
                                                        v-bind:key="index">
                                                        {{name}}
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row question">
                                    <div class="col-12 question__question">
                                        Value
                                        <markdown></markdown>
                                    </div>
                                    <div class="col-12">
                                        <ValidationProvider rules="required|min:3" v-slot="{ errors }">
                                            <input v-model="editingVariable.value" type="text" maxlength="256" class="short-question">
                                            <span class="form__error" v-if="errors">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="sw-modal-actions">
                                    <div v-if="waiting || error || success" class="infobar" v-bind:class="{'infobar-info' : !error, 'infobar-error' : error}">
                                        {{infoMessage}}
                                    </div>
                                    <div v-show="waiting && !success">
                                        <Spinner/>
                                    </div>
                                    <div class="row" v-show="!waiting">
                                        <div class="col text-center">
                                            <button class="btn btn-secondary" v-on:click.stop="cancel">Cancel</button>
                                            <button class="btn btn-primary">
                                                <template v-if="isEditingExistingVariable">Save</template>
                                                <template v-else>Add</template>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </ValidationObserver>
                    </div>
                </div>
            </template>


            <!--  -------------------------- -->
            <!--  Previewing a Variable view -->
            <!--  -------------------------- -->
            <template v-else-if="isPreviewingVariable">
                <div class="row sw-modal-heading">
                    <div class="col"><h4><i class="fas fa-user-alt"></i>Preview a Variable</h4></div>
                </div>
                <div class="sw-modal-body">
                    <div class="sw-modal-actions">
                        <div class="row question">
                            <div class="col-12 question__question">
                                Usage
                            </div>
                            <div class="col-12">
                                <strong><span v-html="'{{'"></span>{{editingVariable.name}}<span v-html="'}}'"></span></strong>
                            </div>
                        </div>
                        <div class="row question" v-if="isRoomTypeVariable">
                            <div class="col-12 question__question text-capitalize">
                                {{getUnitTypeForDisplay}}
                            </div>
                            <div class="col-12">
                                <strong>{{getRoomTypeName(editingVariable.roomTypeReference)}}</strong>
                            </div>
                        </div>
                        <div class="row question">
                            <div class="col-12 question__question">
                                <span v-if="isRoomTypeVariable">
                                    Preview (<strong>one {{getUnitTypeForDisplay}}</strong>)
                                </span>
                                <span v-else>
                                    Preview
                                </span>
                            </div>
                            <div class="col-12 text-note">
                                <span v-if="isRoomTypeVariable">If your booking is for this {{getUnitTypeForDisplay}} only, or if you have only defined
                                this variable for one of the booked {{getUnitTypesPluralForDisplay}}, it will be shown
                                as follows:
                                </span>
                                <div class="preview-variable preview-variable-single">
                                    Lorem ipsum <span v-bind:inner-html.prop="editingVariable.value | marked | noParagraph"></span> dolor sit amet, consectetur adipiscing elit.
                                </div>
                            </div>
                        </div>
                        <div class="row question" v-if="isRoomTypeVariable">
                            <div class="col-12 question__question">
                                Preview (<strong>multiple {{getUnitTypesPluralForDisplay}}</strong>)
                            </div>
                            <div class="col-12 text-note">
                                If your booking is for multiple {{getUnitTypesPluralForDisplay}} and if you have defined
                                this variable for more than one of the booked {{getUnitTypesPluralForDisplay}}, it will
                                be shown as follows:
                                <div class="preview-variable review-variable-multiple">
                                    Lorem ipsum <span v-bind:inner-html.prop="editingVariable.value | marked | noParagraph"></span>, <span v-bind:inner-html.prop="editingVariable.value | marked | noParagraph"></span> dolor sit amet, consectetur adipiscing elit.
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col text-center">
                                <button class="btn btn-primary" v-on:click.stop="closePreview">Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            </template>

        </div>

        <confirm-dialog v-bind:message="confirmDeleteMessage" v-bind:callbackPrimaryName="'delete-variable'" v-bind:callbackPrimaryReference="editingVariable.reference" v-if="showConfirmDeleteVariable"/>
    </div>
</template>

<script>
    import ConfirmDialog from '../ConfirmDialog.vue'
    import Spinner from '../Spinner.vue'
    import { getters } from '../../store.js'
    import Markdown from '../Markdown'
    import { ValidationObserver, ValidationProvider } from 'vee-validate'
    // import Tooltip from '../Tooltip'

    const LISTING_VARIABLES = 0, EDITING_VARIABLE = 1, PREVIEW_VARIABLE = 2;

    // extend('validateRoomType', {
    //     params: ['target'],
    //     validate: value => {
    //         console.log('validating check in & out: ' + value)
    //         let dates = null
    //         if (Array.isArray(value)) {
    //             dates = [dayjs(value[0]).format("YYYY-MM-DD"), dayjs(value[1]).format("YYYY-MM-DD")]
    //         } else {
    //             dates = value.split(" to ")
    //         }
    //         console.log('dates[0]: ' + dates[0])
    //         console.log('dates[1]: ' + dates[1])
    //         if (dates.length === 1) {
    //             return false
    //         }
    //         if (dates[0] === dates[1]) {
    //             return false
    //         }
    //
    //         return true
    //     },
    //     message: 'Check out must be after check in'
    // })

    export default {
        name: 'EditVariables',
        components: {
            ConfirmDialog, Markdown, Spinner, ValidationObserver, ValidationProvider//, Tooltip
        },
        props: {
            establishment: Object
        },
        data: function() {
            return {
                variables: [],
                roomTypeVariables: [],
                mode: LISTING_VARIABLES,
                showSystemVariables: true,
                menuIndex: -1,
                editingVariable: null,
                isRoomTypeVariable: false,
                showExistingVariableNames: false,
                showConfirmDeleteVariable: false,
                waiting: false,
                infoMessage: null,
                success: null,
                error: null,
            }
        },
        filters: {
            noParagraph: function (value) {
                if (!value) {
                    return '';
                }
                value = value.toString();
                return value.replace(/<p>/i, '').replace(/<\/p>/i, '');
            },
        },
        computed: {
            getUnitTypeForDisplay: function() {
                return getters.getCurrentEstablishment().preferences.displayCategoryForRoomTypes;
            },
            getUnitTypesPluralForDisplay: function() {
                switch (getters.getCurrentEstablishment().preferences.displayCategoryForRoomTypes) {
                    case 'unit':
                        return 'units';
                    case 'property':
                        return 'properties';
                    case 'room':
                    default:
                        return 'rooms';
                }
            },
            isListingVariables: function() {
                return this.mode === LISTING_VARIABLES;
            },
            isEditingVariable: function() {
                return this.mode === EDITING_VARIABLE;
            },
            isPreviewingVariable: function() {
                return this.mode === PREVIEW_VARIABLE;
            },
            isEditingExistingVariable: function() {
                return (this.editingVariable && this.editingVariable.reference);
            },
            confirmDeleteMessage: function() {
                return "Are you sure you want to <b>delete the variable '" + this.editingVariable.name + "'</b>?";
            },
            uniqueRoomTypeVariableNames: function() {
                let names = [];
                this.roomTypeVariables.forEach((rtv) => { names.push(rtv.name); });
                const answers = Object.values(names).filter((ans, index, self) => {
                    return self.indexOf(ans) === index
                })
                return answers;
            }
        },
        methods: {
            getRoomTypeName: function(reference) {
                for (let roomType of this.establishment.roomTypes) {
                    if (roomType.reference === reference) {
                        return roomType.name;
                    }
                }
                return "unkonwn";
            },
            toggleVariableMenu: function(index) {
                if (this.menuIndex === index) {
                    this.menuIndex = null;
                } else {
                    this.menuIndex = index;
                }
            },
            isShowVariableMenu: function(index) {
                return this.menuIndex === index;
            },
            previewVariable: function(variable) {
                this.mode = PREVIEW_VARIABLE;
                this.menuIndex = -1;
                this.editingVariable = variable;
                this.isRoomTypeVariable = (this.editingVariable.roomTypeReference !== null && typeof this.editingVariable.roomTypeReference !== 'undefined') ? true : false;
                console.log("previewing variable: " + variable.name);
            },
            editVariable: function (variable) {
                this.mode = EDITING_VARIABLE;
                this.menuIndex = -1;
                this.editingVariable =  { ...variable };
                this.isRoomTypeVariable = (this.editingVariable.roomTypeReference !== null && typeof this.editingVariable.roomTypeReference !== 'undefined') ? true : false;
                this.$nextTick(() => {
                    this.$refs.editVariableName.focus();
                });
            },
            toggleShowingExistingVariables() {
                this.showExistingVariableNames = !this.showExistingVariableNames;
                this.$refs.editVariableName.focus();
            },
            confirmDeleteVariable: function(variable) {
                this.menuIndex = -1;
                this.editingVariable = variable;
                this.showConfirmDeleteVariable = true;
                console.log("deleting variable: " + variable.name);
            },
            addVariable: function(forRoomType) {
                this.mode = EDITING_VARIABLE;
                this.menuIndex = -1;
                this.editingVariable =  { name: "", value: "" };
                this.isRoomTypeVariable = forRoomType;
                if (this.isRoomTypeVariable) {
                    this.editingVariable.roomTypeReference = null;
                    this.$nextTick(() => {
                        this.$refs.editVariableRoomType.focus();
                    });
                } else {
                    this.$nextTick(() => {
                        this.$refs.editVariableName.focus();
                    });
                }
            },
            setAppliesToRoomType: function(applies) {
                this.isRoomTypeVariable = applies;
            },
            copyVariableName: function (name) {
                this.editingVariable.name = name;
            },
            cancel: function () {
                this.mode = LISTING_VARIABLES;
                this.editingVariable = null;
                this.isRoomTypeVariable = false;
            },
            fetchVariables: async function () {
                this.waiting = true;
                this.error = null;

                try {
                    const response = await this.$http.get('/guest-management/v1/establishments/' + this.establishment.reference + '/variables', {
                        withCredentials: true
                    });
                    console.log(response);
                    this.variables.splice(0, this.variables.length);
                    this.roomTypeVariables.splice(0, this.roomTypeVariables.length);
                    if (response.data) {
                        for (let variable of response.data) {
                            if (variable.roomTypeReference !== null) {
                                this.roomTypeVariables.push(variable);
                            } else {
                                this.variables.push(variable);
                            }
                        }
                    }
                    this.sortVariables();
                    this.sortRoomTypeVariables();
                } catch (error) {
                    console.log(error);
                    if (error.response) {
                        this.error = error.response.data.message
                    } else {
                        this.error = "An unknown error occurred while trying to fetch personlisation variables"
                    }
                } finally {
                    console.log("Finished");
                    this.waiting = false;
                }
            },
            sortVariables: function() {
                console.log("Sorting variables");
                this.variables.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });

            },
            sortRoomTypeVariables: function() {
                console.log("Sorting room type variables");
                const self = this;
                this.roomTypeVariables.sort(function(a, b) {
                    let order = a.name.localeCompare(b.name);
                    if (order === 0) {
                        let aRoomTypeName = self.getRoomTypeName(a.roomTypeReference);
                        let bRoomTypeName = self.getRoomTypeName(b.roomTypeReference);
                        if (aRoomTypeName && bRoomTypeName) {
                            return aRoomTypeName.localeCompare(bRoomTypeName);
                        }
                    }
                    return order;
                });
            },
            save: function () {
                this.$refs.variableForm.validate().then(success => {
                    console.log("Validated:" + success);
                    if (!success) {
                        return
                    }

                    this.waiting = true;
                    this.error = false;
                    if (!this.isRoomTypeVariable) {
                        this.editingVariable.roomTypeReference = null;
                    }

                    const body = {
                        name: this.editingVariable.name,
                        value: this.editingVariable.value,
                        roomTypeReference: this.editingVariable.roomTypeReference
                    }

                    if (typeof this.editingVariable.reference === 'undefined') {
                        this.infoMessage = "Creating variable";

                        this.$http.post('/guest-management/v1/establishments/' + this.establishment.reference + '/variables', body
                        ).then(response => {
                            console.log("Variable created:")
                            console.log(response);
                            this.editingVariable.reference = response.data.reference;
                            this.variableAdded(this.editingVariable);
                            if (this.isRoomTypeVariable) {
                                this.sortRoomTypeVariables();
                            } else {
                                this.sortVariables();
                            }
                            this.isRoomTypeVariable = false;
                            this.infoMessage = "Variable created";
                            this.success = true;
                            setTimeout(() => {
                                this.clearEditingSettings();
                            }, 2000);
                        }).catch(error => {
                            this.error = true;
                            this.waiting = false;
                            if (error.response) {
                                this.infoMessage = "Error: " + error.response.data.message
                            } else {
                                this.infoMessage = "Error creating variable";
                            }
                        });
                    } else {
                        this.infoMessage = "Saving variable";

                        body.reference = this.editingVariable.reference;

                        this.$http.put('/guest-management/v1/establishments/' + this.establishment.reference + '/variables/' + this.editingVariable.reference, body
                        ).then(response => {
                            console.log("Variable updated:")
                            console.log(response);
                            this.variableUpdated(this.editingVariable);
                            this.sortVariables();
                            this.infoMessage = "Variable updated";
                            this.success = true;
                            setTimeout(() => {
                                this.clearEditingSettings();
                            }, 2000);
                        }).catch(error => {
                            this.error = true;
                            this.waiting = false;
                            if (error.response) {
                                this.infoMessage = "Error: " + error.response.data.message
                            } else {
                                this.infoMessage = "Error updating variable";
                            }
                        });
                    }
                })
            },
            clearEditingSettings: function() {
                this.success = false;
                this.error = false;
                this.waiting = false;
                this.infoMessage = null;
                this.isRoomTypeVariable = false;
                this.mode = LISTING_VARIABLES;
            },
            variableAdded: function(variable) {
                if (variable.roomTypeReference !== null) {
                    this.roomTypeVariables.push(variable);
                } else {
                    this.variables.push(variable);
                }            },
            variableUpdated: function(variable) {
                for (let i = 0; i < this.variables.length; i++) {
                    let existing = this.variables[i];
                    if (existing.reference === variable.reference) {
                        // are we moving to other list, or just replacing?
                        if (variable.roomTypeReference !== null) {
                            this.variables.splice(i, 1);
                            this.roomTypeVariables.push(variable);
                        } else {
                            this.variables.splice(i, 1, variable);
                        }
                        return;
                    }
                }
                for (let i = 0; i < this.roomTypeVariables.length; i++) {
                    let existing = this.roomTypeVariables[i];
                    if (existing.reference === variable.reference) {
                        // are we moving to other list, or just replacing?
                        if (variable.roomTypeReference === null) {
                            this.roomTypeVariables.splice(i, 1);
                            this.variables.push(variable);
                        } else {
                            this.roomTypeVariables.splice(i, 1, variable);
                        }
                        return;
                    }
                }
            },
            variableDeleted: function(reference) {
                for (let i = 0; i < this.variables.length; i++) {
                    let existing = this.variables[i];
                    if (existing.reference === reference) {
                        this.variables.splice(i, 1);
                        return;
                    }
                }
                for (let i = 0; i < this.roomTypeVariables.length; i++) {
                    let existing = this.roomTypeVariables[i];
                    if (existing.reference === reference) {
                        this.roomTypeVariables.splice(i, 1);
                        return;
                    }
                }
            },
            deleteVariable: async function(reference) {
                try {
                    if (reference) {
                        this.waiting = true;
                        const response = await this.$http.delete('/guest-management/v1/establishments/' + this.establishment.reference + '/variables/' + this.editingVariable.reference, {
                            withCredentials: true
                        });
                        console.log(response);
                        this.variableDeleted(this.editingVariable.reference);
                    }
                } catch (error) {
                    console.log(error);
                    if (error.response) {
                        this.error = "Error: " + error.response.data.message
                    } else {
                        this.error = "Error deleting variable";
                    }
                } finally {
                    this.showConfirmDeleteVariable = false;
                    this.editingVariable = null;
                    this.waiting = false;
                }

            },
            closePreview: function() {
                this.mode = LISTING_VARIABLES;
            },
            close: function() {
                console.log("close edit variables");
                console.log(this.editingVariable);
                this.$root.$emit('finished-editing-establishment-variables');
            },
        },
        mounted() {
            this.fetchVariables();
            this.$root.$on('delete-variable', this.deleteVariable);
        },
        beforeDestroy () {
            this.$root.$off('delete-variable', this.deleteVariable);
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/layout/forms";
    @import "../../styles/components/modal";
    @import "../../styles/components/edit_form_component";
    @import "../../styles/components/variables";
    @import "../../styles/components/edit_variables";
    @import "../../styles/components/question_answer.scss";
</style>
